import { pickDefaultPeriodId } from '@/core/models/phase1.models';
import { recallPeriod, rememberPeriod } from '@/core/periodMemory';
import { selectedClient } from '@/core/selectedClient';
import { trialBalanceService } from '@/core/services/trialBalance';

/** `rememberPeriod` for the client the Accounts shell has selected: what a period dropdown's onChange calls. */
export function rememberChosenPeriod(periodId: string | null | undefined): void {
  rememberPeriod(selectedClient()?.id, periodId);
}

/**
 * The period a screen opens on for this client: see `pickDefaultPeriodId` for the rule. The periods that have data come from
 * the client's trial balance list (each row carries its accounting period and line count); if that cannot be read the rule
 * simply skips its second step, so the screen still opens.
 */
export async function resolveDefaultPeriodId(
  clientId: string,
  periods: readonly { id: string; periodTo?: string | null; isComparative?: boolean }[],
): Promise<string | null> {
  const rememberedId = recallPeriod(clientId);
  let idsWithData: Set<string> | null = null;
  if (periods.length > 1 && !(rememberedId && periods.some((p) => p.id === rememberedId))) {
    try {
      const rows = await trialBalanceService.getTrialBalances(clientId);
      idsWithData = new Set(
        (Array.isArray(rows) ? rows : [])
          .filter((r) => r.accountingPeriodId && Number(r.lineCount) > 0)
          .map((r) => r.accountingPeriodId as string),
      );
    } catch {
      idsWithData = null;
    }
  }
  return pickDefaultPeriodId(periods, { rememberedId, idsWithData });
}
